import { Button, Checkbox, Radio } from "@mui/material";
import { styleHelper } from "../../shared/helpers/styleHelper";
import ProductImage from "../shared/ProductImage";
import TooltipPopup from "../shared/TooltipPopup";
import "./ProductCard.scss";

export enum ProductCardMode {
  SingleSelect = 0,
  MultiSelect = 1,
  AddButton = 2,
}

interface ProductCardProps {
  addTooltip: boolean;
  content: string;
  height?: string;
  //imageLink: string;
  isRecommended?: boolean;
  isSelected: boolean;
  localImage: string;
  mode?: ProductCardMode;
  onChange(): void;
  preContent: string;
  title: string;
  tooltipText: string;
}

const fontSize = 18;
const tooltopMachinefixing = "machineFixingTooltipId";
const ProductCard = ({
  addTooltip,
  content,
  height = "",
  isRecommended = false,
  isSelected,
  localImage,
  mode = ProductCardMode.SingleSelect,
  onChange,
  preContent,
  title,
  tooltipText,
}: ProductCardProps) => {
  return (
    <div
      className={
        isSelected === true
          ? "productCardContainer productCardContainerSelected"
          : "productCardContainer"
      }
      style={{ height }}
    >
      <div
        className={
          mode === ProductCardMode.AddButton
            ? "productCardWrapper productCardContainerButton"
            : "productCardWrapper"
        }
      >
        <div
          className={
            mode === ProductCardMode.AddButton
              ? "productCard productCardButton"
              : "productCard"
          }
          onClick={onChange}
          style={{ cursor: "pointer" }}
        >
          <div>
            <ProductImage
              alt=""
              height={40}
              width={40}
              localSrc={localImage}
            />
          </div>
          <div>
            <div
              className={
                isRecommended
                  ? "productCardPreContent productCardPreContentRecommended"
                  : "productCardPreContent"
              }
            >
              {preContent}
            </div>
            <div className="productCardPreContent"></div>
            <div className="productCardTitle">{title}</div>
            {addTooltip === true && (
              <div className="TooltipCard">
                <TooltipPopup text={tooltipText} id={tooltopMachinefixing} />
              </div>
            )}
            <div
              className="productCardContent"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </div>
          <div className="productCardSelector">
            {mode === ProductCardMode.SingleSelect && (
              <Radio
                checked={isSelected}
                readOnly
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize,
                  },
                  pointerEvents: "none",
                }}
              />
            )}
            {mode === ProductCardMode.MultiSelect && (
              <Checkbox
                checked={isSelected}
                readOnly
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize,
                  },
                  pointerEvents: "none",
                }}
              />
            )}
          </div>
        </div>
        {mode === ProductCardMode.AddButton && (
          <div className="productCardAdd">
            {isSelected && (
              <Button
                variant="contained"
                sx={styleHelper.cardButtonRemove}
                onClick={onChange}
              >
                Ta bort
              </Button>
            )}
            {!isSelected && (
              <Button
                variant="contained"
                sx={styleHelper.cardButtonAdd}
                onClick={onChange}
              >
                Lägg till
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
